export default {
  namespaced: true,
  state: {
    username: '',
    firstName: '',
    lastName: '',
    role: '',
    permissions: []
  },
  mutations: {
    set: function (s, p) {
      s.username = p.username
      s.firstName = p.firstName
      s.lastName = p.lastName
      s.role = p.role
      s.permissions = p.permissions
    },
    clear: function (s) {
      s.username = ''
      s.firstName = ''
      s.lastName = ''
      s.role = ''
    }
  },
}
